export default "__VITE_ASSET__663ace64__"